/**
 * Expandable sections.
 */

const { Expandable } = window.kaplanBlocks;

/**
 * Add event handlers to expand buttons.
 */
const setupFooterMenu = () => {
	const menu = document.querySelector( '.footer-nav' );
	if ( ! menu ) {
		return;
	}

	const enableExpandableMenu = window.getComputedStyle( menu, '::after' ).getPropertyValue( 'content' );
	if ( enableExpandableMenu !== '"enable-expandable-menu"' ) {
		return;
	}

	const items = menu.querySelectorAll( 'h3' );
	items.forEach( heading => {
		const subMenu = heading.nextElementSibling;
		if ( ! subMenu ) {
			return;
		}

		const button = document.createElement( 'button' );

		const id  = heading.parentNode.id + '-submenu';

		button.type = 'button';
		button.setAttribute( 'aria-expanded', false );

		subMenu.id = id;
		button.setAttribute( 'aria-controls', id );

		button.innerHTML = heading.innerHTML;
		heading.replaceChildren( button );
		heading.classList.add( 'has-button' );
	} );

	new Expandable( menu );
};

/**
 * Removes event listeners.
 */
const restoreFooterMenu = () => {
	const menu = document.querySelector( '.footer-nav' );
	if ( ! menu ) {
		return;
	}

	const enableExpandableMenu = window.getComputedStyle( menu, ':before' ).getPropertyValue( 'content' );
	if ( enableExpandableMenu !== '"enable-expandable-menu"' ) {
		return;
	}

	const items = menu.querySelectorAll( 'h3' );
	items.forEach( heading => {
		const button = heading.querySelector( 'button' );
		if ( ! button ) {
			return;
		}
		heading.innerHTML = button.innerHTML;
		heading.classList.remove( 'has-button' );
	} );
};

/**
 * Kick it all off.
 */
const bootstrap = () => {
	setupFooterMenu();
};

/**
 * Re-initialize listeners on updates to this module.
 */
if ( module.hot ) {
	module.hot.accept();
	module.hot.dispose( restoreFooterMenu );
	bootstrap();
} else {
	document.addEventListener( 'DOMContentLoaded', bootstrap );
}
